import React from 'react';

import { Icon } from '../icons';

export const DragAndDropIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 14 14" fill={color} style={style}>
      <g>
        <circle cx="3.62524" cy="3.68732" r="1.96875" />
        <circle cx="3.62524" cy="10.3127" r="1.96875" />
        <circle cx="10.375" cy="3.68732" r="1.96875" />
        <circle cx="10.375" cy="10.3127" r="1.96875" />
      </g>
    </svg>
  );
};
